import { format as fnsFormat } from 'date-fns';

export const formatDate: typeof fnsFormat = (timestamp, format, options): string => {
    try {
        return fnsFormat(timestamp, format, options);
    } catch {
        return '';
    }
};
